module.exports = __webpack_public_path__ + "art.svg?a181d7ea6333e32449d99c68902a7f0e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art.svg
// module id = 117
// module chunks = 0